import './MenuVertical.css'

import {
  FaBookReader,
  FaBuffer,
  FaCubes,
  FaSistrix,
  FaTachometerAlt,
  FaUsers,
} from 'react-icons/fa'
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarHeader,
  SubMenu,
} from 'react-pro-sidebar'

import { Link } from 'react-router-dom'
import React from 'react'
import logo from 'assets/logounad.svg'

// @constants
import { RUTAS } from 'constants/constants'

export default function MenuVertical({ collapsed, toggled, handleToggle }) {
  return (
    <div style={{ position: 'relative', zIndex: 100 }}>
      <ProSidebar
        collapsed={collapsed}
        toggled={toggled}
        breakPoint='md'
        onToggle={handleToggle}
      >
        <SidebarHeader>
          <div
            style={{
              padding: '0 24px',
              textTransform: 'uppercase',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: '1px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              height: '300px',
              textAlign: 'center',
            }}
          >
            <img src={logo} alt='logo' />
          </div>
        </SidebarHeader>

        <SidebarContent>
          <Menu iconShape='circle'>
            <MenuItem icon={<FaTachometerAlt />}>
              <Link to={RUTAS.INICIO}>Dashboard</Link>
            </MenuItem>
          </Menu>
          <Menu iconShape='circle'>
            <MenuItem icon={<FaTachometerAlt />}>
              <Link to={RUTAS.CARGUE_DOCUMENTOS}>Cargar datos</Link>
            </MenuItem>
          </Menu>
          <Menu iconShape='circle'>
            <SubMenu title='Gestión' icon={<FaBuffer />}>
              <MenuItem>
                <Link to={RUTAS.DIMENSION}>Dimensión</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.FACTOR}>Factor</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.CARACTERISTICAS}>Características</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.CARACTERISTICA_GRUPO_INTERES}>
                  Características Grupo de Interés
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.INDICADOR}>Indicador</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.EVIDENCIA_CUMPLIMIENTO}>
                  Evidencia de cumplimiento
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.ESCUELA}>Escuela</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.PROGRAMAS_ACADEMICOS}>Programas académicos</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.ENCUESTAS}>Encuestas</Link>
              </MenuItem>
              <MenuItem>
                <Link to={RUTAS.PREGUNTAS}>Preguntas</Link>
              </MenuItem>
            </SubMenu>

            <SubMenu title='Grupo de Interés' icon={<FaUsers />}>
              <MenuItem>
                <Link to='/'>Estudiantes</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Egresados</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Docentes</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Administrativos y Directivos</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Sector Productivo</Link>
              </MenuItem>
            </SubMenu>

            <SubMenu title='Instrumentos' icon={<FaCubes />}>
              <MenuItem>
                <Link to='/'>Encuesta</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Preguntas Autoevaluación</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Preguntas Encuestas</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Preguntas Caracteristicas pregrado</Link>
              </MenuItem>
              <MenuItem>
                <Link to='/'>Preguntas Caracteristicas maestria</Link>
              </MenuItem>
            </SubMenu>

            <SubMenu title='Autoevaluación programa' icon={<FaBookReader />}>
              <MenuItem>Autoevaluación</MenuItem>
              <MenuItem>Ponderar factor</MenuItem>
              <MenuItem>Gestionar CCP</MenuItem>
              <MenuItem>Ponderar caracteristicas</MenuItem>

              <SubMenu title='Apreciación'>
                <MenuItem>Muestra</MenuItem>
                <MenuItem>Aplicar instrumentos</MenuItem>
                <MenuItem>Seguimiento</MenuItem>
                <MenuItem>Resultados de apreciación</MenuItem>
              </SubMenu>

              <SubMenu title='Evaluación documental'>
                <MenuItem>Evaluación</MenuItem>
                <MenuItem>Resultados</MenuItem>
              </SubMenu>

              <SubMenu title='Informe final'>
                <MenuItem>Resultado autoevaluación </MenuItem>
                <MenuItem>Elaborar informe final</MenuItem>
                <MenuItem>Elaborar plan de mejoramiento</MenuItem>
              </SubMenu>
            </SubMenu>

            <SubMenu title='Consultar' icon={<FaSistrix />}>
              <SubMenu title='Consultar autoevaluación'>
                <MenuItem>Apreciación </MenuItem>
                <MenuItem>Evaluación documental </MenuItem>
                <MenuItem>Informe de autoevaluación </MenuItem>
                <MenuItem>Plan de mejoramiento </MenuItem>
              </SubMenu>
            </SubMenu>
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </div>
  )
}
